<script setup lang="ts">
import PinMenu from "@/components/icons/PinMenu.vue";
import FiltroIcon from "@/components/icons/FiltroIcon.vue";
import ListaIcon from "@/components/icons/ListaIcon.vue";
import ListaView from "@/views/desktop/ListaView.vue";
import FiltroView from "@/views/desktop/FiltroView.vue";
import { useSidebarStore } from '@/stores/sidebar';
useSidebarStore();
</script>

<template>
    <transition name="slide-fade">
        <lista-view v-if="!filtro" :menu-retratil="esconderMenuRetratil" />
    </transition>
    <transition name="slide-fade">
        <filtro-view v-if="filtro" @filtro-aplicado="filtroAplicado()" />
    </transition>
    <div id="second-sidebar" class="sidebar menu-filters-bg mt-4">
        <div class="menu-filters-action">
            <ul class="nav nav-pills nav-flush flex-column mb-auto text-center mt-3 z-3">
                <li>
                    <a href="javascript:void(0)" class="nav-link py-0 rounded-0 icon-margin" @click="selecionarMapa">
                        <pin-menu />
                    </a>
                </li>
                <li class="mt-2">
                    <a href="javascript:void(0)" class="nav-link py-0 rounded-0 icon-margin"
                        @click="selecionarListaDetalhes">
                        <lista-icon />
                    </a>
                </li>
                <li class="mt-3">
                    <a href="javascript:void(0)" class="nav-link py-0 rounded-0" @click="selecionarFiltro">
                        <filtro-icon class="icon-margin" />
                    </a>
                </li>
                <li class="mt-0">
                    <router-link :to="{ name: 'logout' }" class="nav-link ps-2">
                        <i class="bi bi-power logout-button"></i>
                    </router-link>                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import { mapStores } from 'pinia';
import { defineComponent } from "vue";

export default defineComponent({
    name: "MainSidebar",
    data() {
        return {
            filtro: false,
            tipoMenu: 'obras',
        };
    },
    computed: {
        ...mapStores(useSidebarStore),
        esconderMenuRetratil(): boolean {
            return this.$route.name === 'desktop-lista-obra' || this.$route.name === 'desktop-lista'
        },
    },
    mounted() {
        this.tipoMenu = useSidebarStore().menu;
    },
    methods: {
        toggleSidebar() {
            this.SidebarStore.toggle(this.tipoMenu);
        },
        selecionarMapa() {
            if (this.SidebarStore.open)
                this.toggleSidebar();

            if (this.filtro)
                this.filtro = false;

            if (this.$route.name != 'home') {
                this.$router.push('/');
            }
        },
        selecionarListaDetalhes() {
            this.filtro = false;
            this.SidebarStore.open = this.filtro
            this.SidebarStore.menu = ''
            this.$router.push('/desktop/lista');
        },
        selecionarFiltro() {
            this.tipoMenu = '';
            this.filtro = !this.filtro;
            this.SidebarStore.open = this.filtro
        },
        filtroAplicado() {
            this.filtro = false;
            this.SidebarStore.toggle(this.tipoMenu);
        }
    }
});
</script>